import { createMenu } from './createMenu'

class WhiteLabelSideMenuBuilder {
  build(currentLocation?: string, featureType?: string[]): any[] {
    return createMenu(currentLocation, featureType)
  }
}

export const whiteLabelSideMenuBuilder = new WhiteLabelSideMenuBuilder()
